import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  Modal,
  Typography,
} from "@mui/material";
import React from "react";

const CertificateDeleteModal = ({ open, onClose }) => {
  return (
    <Dialog open={open} maxWidth={"xs"} fullWidth onClose={onClose}>
      <DialogContent>
        <Box display={"flex"} flexDirection={"column"} gap={"1.5rem"}>
          <Typography>Delete this certificate?</Typography>
          <Box display={"flex"} gap={"1rem"}>
            <Chip label={"Cancel"} variant="outlined" color="primary" />
            <Chip label={"Delete"} variant="filled" color="primary" />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CertificateDeleteModal;
